import { call, put } from "redux-saga/effects";
import { Creators } from ".";
import { api, ResponseError } from "../../services";

export default function* getUsernameAndRoles() {
  try {
    const response = yield call(api.getUsernameAndRoles);

    yield put(Creators.getUsernameAndRolesSuccess(response));
  } catch (response) {
    const errorResponse = new ResponseError(response);
    errorResponse.alertMessage();
    yield put(Creators.getUsernameAndRolesFailure());
  }
}
